
const DrawSVGUtils = require('../../../viscomjs/utils/DrawSVGUtils');
const utils = {};
DrawSVGUtils.mixin(utils);

module.exports.renderDots = (el, num, dotWidth) => {
    const l = utils.getLength(el);
    const delta = l / num;
    el.attr({
        strokeDasharray: [dotWidth, delta - dotWidth]
    });
};


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/svgAnim/DottedLineUtils.js